import { createSlice } from "@reduxjs/toolkit";
import { fetchDownloadInvoices, fetchInvoices } from "./apiThiunk";

const initialState = {
    invoices: {},
    loading: false,
    error: null,
  };

  const invoicesSlice = createSlice({
    name: "invoices",
    initialState,   
    extraReducers: (builder) => {
      builder.addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      });
      builder.addCase(fetchInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload;
      });
      builder.addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
      builder.addCase(fetchDownloadInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      });   
      builder.addCase(fetchDownloadInvoices.fulfilled, (state, action) => {
        state.loading = false;
      });
      builder.addCase(fetchDownloadInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    },
  });

  const { reducer } = invoicesSlice;
  export { fetchInvoices, fetchDownloadInvoices };
  export default reducer;
